import React, { useState,useEffect } from "react";
import styles from "./sidebar.module.css";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Link,withRouter } from "react-router-dom";

const Sidebar = (props) => {
  const [select, setSelect] = useState(0);
  const params=props.location?.pathname;
  useEffect(()=>{
    if(params==='/curriculum'){
      setSelect(0)
    }
    else if(params==='/curriculum/course-outcome'){
      setSelect(1)
    }
    else if(params==='/curriculum/co-po-maping'){
      setSelect(2)
    }
    else if(params==='/curriculum/manage-topic-tlos'){
      setSelect(3)
    }
    else if(params==='/curriculum/manage-lab-experiment-tlos'){
      setSelect(4)
    }
  },[params])
  return (
    <>
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={select}
        aria-label="Vertical tabs example"
        TabIndicatorProps={{ style: { background: "transparent" } }}
      >
        <Tab
          component={Link}
          to="/curriculum"
          label="Course"
          style={{ minWidth: "100%" }}
          className={select == 0 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(0)}
        />
        <Tab
          component={Link}
          to="/curriculum/course-outcome"
          label="Course Outcome"
          style={{ minWidth: "100%" }}
          className={select == 1 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(1)}
        />
        {/* <Tab
          component={Link}
          to="/curriculum/co-po-maping"
          label="CO to PO Maping"
          style={{ minWidth: "100%" }}
          className={select == 2 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(2)}
        /> */}
        <Tab
          component={Link}
          to="/curriculum/manage-topic-tlos"
          label="Manage Topic and TLOs"
          style={{ minWidth: "100%" }}
          className={select == 3 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(3)}
        />
        <Tab
          component={Link}
          to="/curriculum/manage-lab-experiment-tlos"
          label="Manage Lab Experiment and TLOs"
          style={{ minWidth: "100%" }}
          className={select == 4 ? styles.activeTab : undefined}
          onClick={(e) => setSelect(4)}
        />
      </Tabs>
    </>
  );
};

export default withRouter(Sidebar);
